import { parseScaleReading, SCALE_REQUEST, type ScaleReading } from '@makila/pos-core';
import { findSerial, nativeBridge, type SerialPortLike } from './devices';
import { loadHw } from './printer';

let port: SerialPortLike | undefined;
export const setLiveScale = (p: SerialPortLike) => { port = p; };
export const scaleConfigured = () => loadHw().scale.kind !== 'none';

/**
 * Lê o peso da balança de caixa: pede-o (Toledo "W", ENQ) ou escuta o que ela
 * envia sem parar, até uma leitura estável ou o fim do prazo. Devolve a última
 * leitura (estável ou não) — o ecrã mostra-a e só deixa juntar à venda a estável.
 */
export async function readScale(timeoutMs = 2500): Promise<ScaleReading | null> {
  const c = loadHw().scale;
  if (c.kind === 'native') {
    const n = nativeBridge();
    if (!n || !c.ref?.nativeId) throw new Error('Balança do terminal por escolher (Equipamento)');
    return parseScaleReading(await n.readScale(c.ref.nativeId, c.protocol, c.baudRate));
  }
  if (c.kind !== 'serial' || !c.ref) return null;
  port ??= await findSerial(c.ref);
  if (!port) throw new Error('Balança não encontrada (ligue o cabo ou volte a escolhê-la em Equipamento)');
  if (!port.readable) await port.open({ baudRate: c.baudRate });
  const req = SCALE_REQUEST[c.protocol];
  if (req) { const w = port.writable!.getWriter(); try { await w.write(req); } finally { w.releaseLock(); } }
  const reader = port.readable!.getReader();
  const dec = new TextDecoder('latin1');
  let text = '', last: ScaleReading | null = null;
  const timer = setTimeout(() => { void reader.cancel(); }, timeoutMs);
  try {
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      text = (text + dec.decode(value)).slice(-400);
      last = parseScaleReading(text) ?? last;
      // Toledo/ENQ: uma resposta chega; contínua: espera pela estável.
      if (last?.stable && (req || /[\r\n]$/.test(text))) break;
    }
  } finally {
    clearTimeout(timer);
    try { await reader.cancel(); } catch { /* já cancelado */ }
    reader.releaseLock();
  }
  return last;
}
